export default {
  automationsLogTimeFrames: state => {
    return state.automationsLogTimeFrames;
  },
  automationLogTimestampStart: state => {
    return state.automationLogTimestampStart;
  },
  automationsLog: state => {
    return state.automationsLog;
  },
  automationLogById: state => id => {
    return state.automationsLog.filter(item => {
      return parseInt(item.automation_id, 10) === parseInt(id, 10);
    });
  },
  automationsLogFilters: state => {
    return state.automationsLogFilters;
  }
};